export default __webpack_public_path__ + "static/media/offers.08121750.svg";